<template>
  <div>
    <!-- <img src="../../static/images/Decs_banner2.png" alt="" class="DescLogo2"> -->
    <div class="container" style="background:#fff;width:100%">
      <div class="p-2">
        <h2
          class="text-center p-2"
          style="text-align:center;font-size:36px;font-weight:600"
        >
          高速钢圆锯片材料
        </h2>
        <!-- <div class="Titleline"></div> -->
      </div>

      <div class=" p-2" style="background:;height:800px">
        <div class="proHomecontainer">
          <div style="margin:20px 0">
            <div class="left1-3 col-md-6" style="padding:5px ">
              <h1 class="ProM-title" style="margin:30px 0">
                {{ $t("Promaterial.DMo5ti") }}
              </h1>
              <div class="ProM-desc">
                <p>
                  {{ $t("Promaterial.DMo5") }}

                  <!-- HSS-DMo5 在 AISI质量体系标准中称为 M2高速钢材质，硬度在64±1HRC。该高速钢是制造金属圆锯片的标准基本材料,也是国际上使用最为广泛的高速钢材质，具有良好的韧性和高耐磨性，用这种材料生产制成的高速钢圆锯片对锯切中低抗拉强度(≤800N/MM²)的金属工件具有理想的切屑效果，即使在锯切不锈钢领域，仍具有良好的锯切性能。 -->
                </p>
              </div>
            </div>

            <div
              class=" right2-3 col-md-6"
              style="margin-top: 0;margin-bottom: 10px;color: #000;padding-left:20px "
            >
              <div class="ProM-pics" style="margin:30px 0">
                <b-row v-for="(items, no1index) in ProMimg" :key="no1index">
                  <b-col
                    v-for="(item, subindex) in items"
                    class="picboxes"
                    :key="subindex"
                  >
                    <b-img :src="item.src" fluid></b-img>
                  </b-col>
                </b-row>
              </div>
              <div>
                <h1 class="ProM-title" style="margin:10px 0">
                  {{ $t("Promaterial.Co5%ti") }}
                </h1>
                <div class="ProM-desc">
                  <p>
                    {{ $t("Promaterial.Co5%") }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      mainImg: [
        { src: require("../../../static/Updatedimg/HSS-material.jpg") },
      ],

      ProMimg: [
        [
          { src: require("../../../static/Updatedimg/9/Corp-2.jpg") },
          { src: require("../../../static/Updatedimg/9/prom-3.jpg") },
          { src: require("../../../static/Updatedimg/9/Tech&News.jpg") },
        ],
        [
          { src: require("../../../static/Updatedimg/9/swiper-1.jpg") },
          { src: require("../../../static/Updatedimg/9/Corp-3.jpg") },
          { src: require("../../../static/Updatedimg/9/swiper-3.jpg") },
        ],
        [
          { src: require("../../../static/Updatedimg/9/prom-2.jpg") },
          { src: require("../../../static/Updatedimg/9/swiper-2.jpg") },
          { src: require("../../../static/Updatedimg/9/prom-1.jpg") },
        ],
      ],

      // 视频播放
    };
  },
};
</script>
<style scoped>
.ProM-title {
  font-family: Helvetica, "Hiragino Sans GB", "Microsoft Yahei", "微软雅黑",
    Arial, sans-serif;
}

@media (min-width: 768px) {
  .left1-3 {
    -ms-flex: 0 0 30%;
    -webkit-box-flex: 0;
    flex: 0 0 30%;
    max-width: 30%;
  }
  .right2-3 {
    -ms-flex: 0 0 70%;
    -webkit-box-flex: 0;
    flex: 0 0 70%;
    max-width: 70%;
  }
}

.ProM-desc {
  line-height: 1.8;
  margin-bottom: 20px;
  word-wrap: break-word;
}
.ProM-desc p {
  overflow: hidden;
  font-size: 14px;
}
.picboxes {
  padding: 2px;
}
</style>

<style>
.DescLogo {
  visibility: hidden;
  animation: bottom-top 1s linear forwards;
  padding-right: 30px;
  width: 50%;
}
.DescLogo2 {
  width: 100%;
}
.Desc_main {
  font-size: 16px;
  padding-top: 20px;
  padding-bottom: 30px;
}

.ParamsPic .row {
  padding-bottom: 10px;
}
</style>
